'use strict';

var _ = require('lodash');
var FormulaEvalService = function FormulaEvalService() {
  function compute(formula, values) {
    if (_.isString(formula)) {
      return values[formula];
    } else if (_.isNumber(formula)) {
      return formula;
    }
    var leftValue = compute(formula.leftOperand, values);
    var rightValue = compute(formula.rightOperand, values);
    var isFraction = formula.fraction ? true : false;
    if (!_.isNumber(leftValue) || !_.isNumber(rightValue)) {
      return '';
    }
    var result;
    switch (formula.operator) {
      case '+':
        result = leftValue + rightValue;
        break;
      case '-':
        result = leftValue - rightValue;
        break;
      case '*':
        result = leftValue * rightValue;
        break;
      case '/':
        result = leftValue / rightValue;
        break;
    }
    return isFraction ? result * 100 / 100 : Math.round(result * 100) / 100;
  }
  return {
    compute: compute
  };
};
FormulaEvalService.$inject = [];
module.exports = FormulaEvalService;